'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Form
 *    Scripts to animate form input placeholder/label
 *
 *  Version:
 *    1.0.0 - 2020/05/29
 */

var FORM_INPUT_GROUP_SELECTOR = '[data-form-input-group]';

var CLASS_PLACEHOLDER = 'is-placeholder-text';

var LABEL_SELECTOR = 'label';

var INPUT_SELECTOR = '.o-input';

var FormInputGroup = function FormInputGroup(container) {
  var _this = this;

  (0, _classCallCheck3.default)(this, FormInputGroup);

  this.onInputFocus = function (e) {
    _this.label.classList.remove(CLASS_PLACEHOLDER);
  };

  this.onInputBlur = function (e) {
    var value = e.target.value;

    if (!value || value == '') _this.label.classList.add(CLASS_PLACEHOLDER);
  };

  this.container = container;
  this.label = container.find(LABEL_SELECTOR)[0];
  this.input = container.find(INPUT_SELECTOR)[0];
  this.input.onfocus = this.onInputFocus;
  this.input.onblur = this.onInputBlur;

  if (!this.input.value || this.input.value == '') this.label.classList.add(CLASS_PLACEHOLDER);else this.label.classList.remove(CLASS_PLACEHOLDER);
};

$(document).ready($(FORM_INPUT_GROUP_SELECTOR).each(function (i, e) {
  return new FormInputGroup($(e));
}));